import React from "react";
import "./components/NeoLoanCards.css";

const loanData = [
  {
    title: "Home Loan",
    rate: "7.35%*",
    features: [
      "Lowest Rates, Fastest Approvals, Happiest Homes",
      "From Foundation to Front Door – We’ve Got You.Mortbuzz",
      "Public Sector Only Now Take Your Quick Home Loan",
      "Lowest Interest Guaranteed with The Trust Of MortBuzz",
      "Upto 100% Cashback on Charges No Bank only MortBuzz",
      "Doorstep Service"
    ]
  },
  {
    title: "Loan Against Property",
    rate: "8.40%*",
    features: [
      "Your Property’s Power, Your Financial Freedom From MortBuzz",
      "Safe, Secured, and Smart – That’s LAP with Mortbuzz",
      "Funding Upto: 85% of Market Value From mortbuzz",
      "Guaranteed Lowest Rate of Interest Easy To Apply",
      "Providing Best Bank for Your Services Only Done By Mortbuzz",
      "Doorstep Service"
    ]
  },
  {
    title: "Commercial Loan",
    rate: "8.40%*",
    features: [
      "Funding Upto 100% Guaranteed Commercial Loan From Mortbuzz",
      "Power Your Business Property Goals With MortBuzz",
      "Strong Funding for Stronger Business Foundations",
      "Boost Business Expansion With Mortbuzz Your CL parterner",
      "Flexible Terms & Tenure Easy To Online Apply @ Mortbuzz.in",
      "Secure & Transparent Process"
    ]
  },
  {
    title: "Personal Loan",
    rate: "10.35%*",
    features: [
      "Upto 100% Cashback On All Bank Charges",
      "From Weddings to Vacations – We've Got You Covered.",
      "Quick Approval & Disbursal",
      "Minimal Documentation",
      "Flexible Tenure Options",
      "No Collateral Needed just go apply now page fill the form"
      
    ]
  },
  {
    title: "Business Loan",
    rate: "9.00%*",
    features: [
      "From Startup to Scale-Up – We Fund the Journey.",
      "Fuel Your Business Growth with Our Support",
      "High Loan Amounts",
      "Quick Disbursal",
      "Flexible Repayment Plans",
      "Funding available up to 200% of the collateral property value."
    ]
  },
  {
    title: "Car Loan",
    rate: "7.60%*",
    features: [
      "Accelerate Your Journey with Instant Car Loans.",
      "Drive your dream car today with our hassle-free car loan",
      "Attractive Interest Rates",
      "Minimal Documentation",
      "Flexible Tenure Options",
      "Available for New Cars From Showroom not for secon owner"
      
    ]
  }
];

const NeoLoanCards = () => {
  return (
    <div className="neo-card-container">
      {loanData.map((card, index) => (
        <div className="neo-card" key={index}>
          <div className="card-content">
            <h3 className="card-title-neo">{card.title}</h3>
            <div className="interest-rate">{card.rate}</div>
            <ul className="features-list">
              {card.features.map((feature, idx) => (
                <li key={idx}>
                  <i className="fas fa-check-circle"></i> {feature}
                </li>
              ))}
            </ul>
            <a href="/apply-now">
              <button className="apply-btn">
                Apply Now <i className="fas fa-arrow-right"></i>
              </button>
            </a>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NeoLoanCards;
